/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import { useReducer } from 'react';
import './style.css';

export const Tag = ({
    text = 'Tag',
    stateProp,
    style,
    size,
    className,
    onClick,
    isClickable,
}) => {
    const [state, dispatch] = useReducer(reducer, {
        state: stateProp || 'default',
        style: style || 'default',
        size: size || 'default',
    });

    function isClickableButton(isClickable) {
        if (null == isClickable) {
            return true;
        } else if (null != isClickable && isClickable) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <button
            className={`tag size-${state.size} state-1-${state.state} style-11-${state.style} ${className}`}
            style={{
                cursor: isClickableButton(isClickable) ? 'pointer' : 'default',
            }}
            onMouseLeave={() => {
                dispatch('mouse_leave');
            }}
            onMouseEnter={() => {
                // If isClickable is not set, show mouse pointer cursor; if isClickable is set and true, then
                // also show mouse pointer cursor; otherwise show default cursor
                if (isClickableButton(isClickable)) {
                    console.log('yo');
                    dispatch('mouse_enter');
                }
            }}
            onClick={(e) => {
                // If isClickable is not set, handle clicks; if isClickable is set and true, then also handle
                // clicks; otherwise ignore
                if (isClickableButton(isClickable)) {
                    dispatch('click');

                    if (null != onClick) {
                        onClick();
                    }
                }
            }}
        >
            <div className="div-3">
                {((state.size === 'default' && state.style === 'default') ||
                    (state.size === 'small' &&
                        state.state === 'inactive' &&
                        state.style === 'featured') ||
                    (state.state === 'active' && state.style === 'featured') ||
                    (state.state === 'default' && state.style === 'featured') ||
                    (state.state === 'hover' &&
                        state.style === 'featured')) && (
                    <div className="text-wrapper-8">{text}</div>
                )}

                {['default', 'small'].includes(state.size) &&
                    (state.size === 'default' || state.style === 'default') &&
                    (state.size === 'small' || state.state === 'inactive') &&
                    (state.size === 'small' || state.style === 'featured') &&
                    (state.state === 'inactive' || state.style === 'default') &&
                    ['default', 'featured'].includes(state.style) && (
                        <>{text}</>
                    )}
            </div>
        </button>
    );
};

function reducer(state, action) {
    if (
        state.size === 'default' &&
        state.state === 'default' &&
        state.style === 'default'
    ) {
        switch (action) {
            case 'mouse_enter':
                return {
                    size: 'default',
                    state: 'hover',
                    style: 'default',
                };
        }
    }

    switch (action) {
        case 'click':
            return {
                size: 'default',
                state:
                    null == state.state || 'active' == state.state
                        ? 'default'
                        : 'active',
                style: 'default',
            };
    }

    if (
        state.size === 'default' &&
        state.state === 'hover' &&
        state.style === 'default'
    ) {
        switch (action) {
            case 'mouse_leave':
                return {
                    size: 'default',
                    state: 'default',
                    style: 'default',
                };

            case 'click':
                return {
                    size: 'default',
                    state: 'active',
                    style: 'default',
                };
        }
    }

    if (
        state.size === 'small' &&
        state.state === 'default' &&
        state.style === 'default'
    ) {
        switch (action) {
            case 'mouse_enter':
                return {
                    size: 'small',
                    state: 'inactive',
                    style: 'default',
                };
        }
    }

    if (
        state.size === 'small' &&
        state.state === 'inactive' &&
        state.style === 'default'
    ) {
        switch (action) {
            case 'mouse_leave':
                return {
                    size: 'small',
                    state: 'default',
                    style: 'default',
                };

            case 'click':
                return {
                    size: 'small',
                    state: 'hover',
                    style: 'default',
                };
        }
    }

    if (
        state.size === 'default' &&
        state.state === 'default' &&
        state.style === 'featured'
    ) {
        switch (action) {
            case 'mouse_enter':
                return {
                    size: 'default',
                    state: 'hover',
                    style: 'featured',
                };
        }
    }

    if (
        state.size === 'default' &&
        state.state === 'hover' &&
        state.style === 'featured'
    ) {
        switch (action) {
            case 'mouse_leave':
                return {
                    size: 'default',
                    state: 'default',
                    style: 'featured',
                };

            case 'click':
                return {
                    size: 'default',
                    state: 'active',
                    style: 'featured',
                };
        }
    }

    if (
        state.size === 'small' &&
        state.state === 'default' &&
        state.style === 'featured'
    ) {
        switch (action) {
            case 'mouse_enter':
                return {
                    size: 'small',
                    state: 'hover',
                    style: 'featured',
                };
        }
    }

    if (
        state.size === 'small' &&
        state.state === 'hover' &&
        state.style === 'featured'
    ) {
        switch (action) {
            case 'mouse_leave':
                return {
                    size: 'small',
                    state: 'default',
                    style: 'featured',
                };

            case 'click':
                return {
                    size: 'small',
                    state: 'active',
                    style: 'featured',
                };
        }
    }

    if (
        state.size === 'default' &&
        state.state === 'active' &&
        state.style === 'default'
    ) {
        switch (action) {
            case 'click':
                return {
                    size: 'default',
                    state: 'default',
                    style: 'default',
                };
        }
    }

    if (
        state.size === 'small' &&
        state.state === 'hover' &&
        state.style === 'default'
    ) {
        switch (action) {
            case 'click':
                return {
                    size: 'small',
                    state: 'default',
                    style: 'default',
                };
        }
    }

    if (
        state.size === 'default' &&
        state.state === 'active' &&
        state.style === 'featured'
    ) {
        switch (action) {
            case 'click':
                return {
                    size: 'default',
                    state: 'default',
                    style: 'featured',
                };
        }
    }

    if (
        state.size === 'small' &&
        state.state === 'active' &&
        state.style === 'featured'
    ) {
        switch (action) {
            case 'click':
                return {
                    size: 'small',
                    state: 'default',
                    style: 'featured',
                };
        }
    }

    return state;
}

Tag.propTypes = {
    text: PropTypes.string,
    stateProp: PropTypes.oneOf(['hover', 'inactive', 'active', 'default']),
    style: PropTypes.oneOf(['featured', 'default']),
    size: PropTypes.oneOf(['small', 'default']),
};
